import { useLocation, useSearchParams } from "react-router-dom";
import InventorySearch from "../components/search/InventorySearch";
import useBodyLock from "../hooks/useBodyLock";
import useEscape from "../hooks/useEscape";
import useOverlay from "../hooks/useOverlay";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const location = useLocation();
  const { close } = useOverlay();

  useBodyLock("v134SearchOpen");
  useEscape(close);

  // Typing rewrites the URL in place and keeps the background page.
  const setQuery = (q) => setParams(q ? { q } : {}, { replace: true, state: location.state });

  return <InventorySearch query={params.get("q") || ""} onQueryChange={setQuery} onClose={close} />;
}
